import { styled } from "@mui/material/styles";
import MaterialTable, { TableProps } from "@mui/material/Table";
import React, { FC } from "react";
import { COLOR_WHITE } from "../../constants/styles";

const StyledTable = styled(MaterialTable)`
  background: ${COLOR_WHITE};
  /* overflow: hidden; */
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2), 0px 0px 1px rgba(9, 30, 66, 0.31);
  border-radius: 3px;
`;

export const Table: FC<TableProps> = (props) => <StyledTable {...props} />;
